import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {
  SCHEDULE_ITEM_TYPES,
  SCHEDULE_TYPES_HUMAN_VALUES,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

import {formatDate} from 'utils/datetime';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import PaymentStatusTag from 'components/PaymentStatusTag';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

const OverpaymentRow = ({
  overpayment,
  handleRowClick,
  redirectToBookingDetail,
  advancedMode
}) => {
  const {overpaymentDetails} = overpayment;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: overpayment.highlighted
      })}
      onClick={() =>
        handleRowClick({
          item: SCHEDULE_ITEM_TYPES.OVERPAYMENT,
          itemId: overpayment.id,
          scheduleType: SCHEDULE_TYPES[overpayment.scheduleType],
          tenancyId: overpaymentDetails.tenancyId
        })
      }>
      <Table.Cell className="booking">
        <ClickIconWithNoPropagation
          onClick={() =>
            redirectToBookingDetail({bookingId: overpayment.bookingId})
          }>
          <div className="colab-bold">#{overpayment.bookingId}</div>
        </ClickIconWithNoPropagation>
      </Table.Cell>
      <Table.Cell className="date">{formatDate(overpayment.date)}</Table.Cell>
      {advancedMode && <Table.Cell className="dueDate" />}
      <Table.Cell className="type">
        <div className="colab-centered-v">
          {overpaymentDetails.hasXeroErrors && <Alert />}
          <div className="colab-centered-v">Overpayment</div>
        </div>
      </Table.Cell>
      <Table.Cell className="description">
        {overpaymentDetails.description}
      </Table.Cell>
      <Table.Cell className="category">
        {_.get(SCHEDULE_TYPES_HUMAN_VALUES, overpayment.scheduleType)}
      </Table.Cell>
      <Table.Cell className="status">
        {overpaymentDetails.voided && (
          <PaymentStatusTag status={PaymentStatusTag.VOIDED} />
        )}
      </Table.Cell>
      {advancedMode && <Table.Cell className="due" />}
      <Table.Cell className="amount payment">
        <Money
          amount={overpayment.amount}
          balance
          className={classNames({
            strikeThrough: overpaymentDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell className="balance">
        <Money amount={overpayment.balance} balance />
      </Table.Cell>
      <Table.Cell className="mode" />
    </Table.Row>
  );
};

export default OverpaymentRow;
